<div class="page-not-found-component">
    <div style="font-weight: bold; font-size: 150px;">404</div>
</div>
